import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../services/user";
import { getCarpetas, putUMACarpeta, removeUMACarpeta } from "../../../services/api";
import folder from "../../../../assets/img/folder.svg";
import IconAdd from "../../../../assets/icons/addblue.svg";
import ActiveIcon from '../../../../assets/icons/activeIcon.svg'
import VectorRight from '../../../../assets/icons/line.svg'
import { toast } from "react-toastify";
import alertConfiguration from "../../../utils/alertsUtils";
import { getCarpetasLibros, putLibroCarpeta, removeLibroCarpeta } from "../../../services/Api/Constructor/Libros";
import { getCarpetasPrimariasTareas, putTareaCarpeta, removeTareaCarpeta } from "../../../services/Api/Tareas";
import NimbusModal from "../../../fragments/NimbusModal";

/**
 * Renglón de la lista de carpetas. Mantiene los iconos que ya se usaban
 * —el de carpeta con su color, la línea de anidado y el check de seleccionado—
 * dentro del estilo de lista del resto de la plataforma.
 */
const FilaCarpeta = ({ seleccionada, onClick, icono, nombre, anidada = false }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex items-center gap-2 px-3 py-2 text-left transition ${
      seleccionada ? "bg-nimbus/5" : "hover:bg-gray-50"
    } ${anidada ? "pl-2" : ""}`}
  >
    {anidada && (
      <img className="w-5 gray-svg flex-shrink-0" src={VectorRight} alt="" />
    )}
    {icono}
    <span className="flex-1 min-w-0 truncate text-sm text-nimbusDark">
      {nombre}
    </span>
    <img
      className="w-5 h-5 flex-shrink-0"
      src={seleccionada ? ActiveIcon : IconAdd}
      alt=""
    />
  </button>
);


const ModalAgregarACarpeta = ({ idUma, idLibro, idTarea, isOpen, setIsOpen, reload, isLibro = false, isTarea=false }) => {
    const { user } = useContext(UserContext);
    const [dataCarpetas, setDataCarpetas] = useState([]);
    const [idFolderSelected, setFolderId] = useState('')

  const handleConfirmation = async () => {
    let obj = isLibro ? 
      {'idLibro': idLibro, 'user': user._id}
      : isTarea ?
      {'idTarea': idTarea, 'user': user._id}
      :
      {'idUma': idUma, 'user': user._id} 

    if(idFolderSelected !== 'raiz'){
      if(isLibro){
        await putLibroCarpeta(idFolderSelected, obj).then(response => {
          if(response?.response?.error?.status == 500){
            toast.error(`${response.response.error.message}`, alertConfiguration)
          }else{             
            setIsOpen(false);
            toast.success('Se movió el contenido a la carpeta', alertConfiguration)
            reload();
          }
        }).catch(error=>{
          console.log(error);
        })
        return;
      }
      if(isTarea){
        await putTareaCarpeta(idFolderSelected, obj).then(response => {
          if(response?.response?.error?.status == 500){
            toast.error(`${response.response.error.message}`, alertConfiguration)
          }else{             
            setIsOpen(false);
            toast.success('Se movió el contenido a la carpeta', alertConfiguration)
            reload();
          }
        }).catch(error=>{
          console.log(error);
        })
        return;
      }
      await putUMACarpeta(idFolderSelected, obj).then(response => {
        if(response?.response?.error?.status == 500){
          toast.error(`${response.response.error.message}`, alertConfiguration)
        }else{
          setIsOpen(false);
          toast.success('Se movió el contenido a la carpeta', alertConfiguration)
          reload("CONTENIDO_MOVIDO");
        }
      }).catch(error=>{
          console.log(error)
      })
    }else{
      if(isLibro){
        await removeLibroCarpeta(obj).then(response => {
          if(response?.error?.status == 500){
            toast.error(`${response.error.message}`, alertConfiguration)
          }else{
            setIsOpen(false);
            if(response.status){
              toast.success(response.mensaje, alertConfiguration)
            }else{
              toast.error(response.mensaje, alertConfiguration)
            }
            reload();
          }
        }).catch(error=>{
            console.log(error)
        })
        return;
      }
      if(isTarea){
        await removeTareaCarpeta(obj).then(response => {
          if(response?.error?.status == 500){
            toast.error(`${response.error.message}`, alertConfiguration)
          }else{
            setIsOpen(false);
            if(response.status){
              toast.success(response.mensaje, alertConfiguration)
            }else{
              toast.error(response.mensaje, alertConfiguration)
            }
            reload();
          }
        }).catch(error=>{
            console.log(error)
        })
        return
      }
      await removeUMACarpeta(obj).then(response => {
        if(response?.response?.error?.status == 500){
          toast.error(`${response.response.error.message}`, alertConfiguration)
        }else{
          setIsOpen(false);
          if(response.response.data.status){
            toast.success(response.response.data.mensaje, alertConfiguration)
          }else{
            toast.error(response.response.data.mensaje, alertConfiguration)
          }
          reload("CONTENIDO_MOVIDO");
        }
      }).catch(error=>{
          console.log(error)
      })
    }
  };

  const setFolder = (id) => {
    setFolderId((idFolderSelected === id)? '' : id)
  };

  const setFolderRaiz = () => {
    //Se agrega función para uma de carpetas propias
    setFolderId((idFolderSelected === 'raiz')? '' : 'raiz')
  };

  useEffect(async () => {
    if(isOpen){
        setFolder('')
      if(isLibro){
        await getCarpetasLibros(user._id).then(response=>{
          let carpetasOrdenadas = [];
          response.forEach((element) => {
            carpetasOrdenadas.push(element);
            if (element.carpetas.length > 0) {
              element.carpetas.forEach((carpeta) => {
                carpetasOrdenadas.push(carpeta);
              });
            }
          });
          setDataCarpetas(carpetasOrdenadas);
        });
        return;
      }
      else if(isTarea){
        await getCarpetasPrimariasTareas(user._id).then((r)=>{
          let carpetasOrdenadas = [];
          r.forEach((element) => {
            carpetasOrdenadas.push(element);
            if (element.carpetas.length > 0) {
              element.carpetas.forEach((carpeta) => {
                carpetasOrdenadas.push(carpeta);
              });
            }
          });
          setDataCarpetas(carpetasOrdenadas);
        })
        return
      }
      await getCarpetas(user._id).then(response=>{
        let carpetasOrdenadas = [];
        response.data.forEach((element) => {
          carpetasOrdenadas.push(element);
          if (element.carpetas.length > 0) {
            element.carpetas.forEach((carpeta) => {
              carpetasOrdenadas.push(carpeta);
            });
          }
        });
        setDataCarpetas(carpetasOrdenadas);
      });
    }
  }, [isOpen])

  return (
    <NimbusModal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      variant="info"
      title="Mover a carpeta"
      onCancel={() => setIsOpen(false)}
      onConfirm={handleConfirmation}
      confirmText="Mover"
      confirmDisabled={idFolderSelected === ""}
    >
      <div className="w-full sm:w-[26rem] max-w-full">
        <p className="text-sm text-gray-500 mb-4">
          {dataCarpetas.length > 0
            ? "Selecciona la carpeta a la que quieres mover la lección o evaluación."
            : "Todavía no tienes carpetas. Puedes regresar el contenido al listado principal."}
        </p>

        <div className="flex flex-col border-2 border-gray-300 rounded-lg max-h-72 overflow-y-auto divide-y divide-gray-100">
          <FilaCarpeta
            seleccionada={idFolderSelected === "raiz"}
            onClick={() => setFolderRaiz()}
            icono={
              <span className="w-6 text-center text-gray-400 flex-shrink-0">/</span>
            }
            nombre="Listado de contenidos principal"
          />
          {dataCarpetas.map((e) => (
            <FilaCarpeta
              key={e._id}
              seleccionada={idFolderSelected === e._id}
              onClick={() => setFolder(e._id)}
              anidada={Number(e.nivel) !== 0}
              icono={
                <img
                  className={`${e.color}-folder w-6 flex-shrink-0`}
                  src={folder}
                  alt=""
                />
              }
              nombre={e.nombre}
            />
          ))}
        </div>
      </div>
    </NimbusModal>
  );
};

export default ModalAgregarACarpeta;
